import type { JSX } from "react";
import { CommandCopy } from "../molecules/CommandCopy.tsx";
import {
  LABD_ABILITIES,
  LABD_ACCESS_NOTE,
  LABD_DOORS,
  LABD_GUARDRAIL,
  LABD_MODES,
  type LabdDoor,
} from "../../lib/labd.ts";

function DoorCard({ door }: { door: LabdDoor }): JSX.Element {
  return (
    <article className="home-labd-door">
      <p className="home-labd-kicker">{door.kicker}</p>
      <h3>{door.title}</h3>
      <p>{door.line}</p>
      {door.command && <CommandCopy command={door.command} />}
      {door.link && (
        <a className="home-labd-link" href={door.link.href} target="_blank" rel="noopener">
          {door.link.label}
        </a>
      )}
    </article>
  );
}

function Abilities(): JSX.Element {
  return (
    <div>
      <h3>What it does</h3>
      <ul className="home-labd-list">
        {LABD_ABILITIES.map((line) => (
          <li key={line}>{line}</li>
        ))}
      </ul>
    </div>
  );
}

function Modes(): JSX.Element {
  return (
    <div>
      <h3>You decide how much it does alone</h3>
      <dl className="home-labd-modes">
        {LABD_MODES.map((mode) => (
          <div key={mode.name} className="home-labd-mode">
            <dt>{mode.name}</dt>
            <dd>{mode.line}</dd>
          </div>
        ))}
      </dl>
      <p className="home-labd-guard">{LABD_GUARDRAIL}</p>
    </div>
  );
}

/** "Meet labd": the three places it runs, what it does, and its permission modes. */
export function LabdSection(): JSX.Element {
  return (
    <section id="labd" className="home-wrap home-labd" aria-labelledby="labd-title">
      <div className="home-labd-head">
        <p className="home-labd-kicker">AI tool from The Dev Labs · free to install</p>
        <h2 id="labd-title" tabIndex={-1}>
          Meet labd
        </h2>
        <p className="home-labd-lede">
          One lab assistant in three places. It reads what you're actually looking at and answers
          like a good lab demonstrator: what's happening, what to change, and the concept behind
          the fix.
        </p>
        <p className="home-labd-note">{LABD_ACCESS_NOTE}</p>
      </div>
      <div className="home-labd-doors">
        {LABD_DOORS.map((door) => (
          <DoorCard key={door.id} door={door} />
        ))}
      </div>
      <div className="home-labd-details">
        <Abilities />
        <Modes />
      </div>
    </section>
  );
}
